import {ActivatedRoute} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {CommonService} from '../../services/common.service';
import {Component, OnInit} from '@angular/core';
import {EventLogsService} from '../../services/event-logs.service';
import {MatDialog} from '@angular/material';
import {MiniTableAgreementInfoComponent} from '../mini-table-agreement-info/mini-table-agreement-info.component';
import {SimpleConfirmActionDialogComponent} from '../../common/simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {ToastMessagesService} from '../../services/toast-messages.service';

@Component({
  styleUrls: ['./agreement-details.component.scss'],
  templateUrl: './agreement-details.component.html'
})
export class AgreementDetailsComponent implements OnInit {
  private detailsId: number;
  private user: any;
  public basicDetailsConfig: any;
  public details: any;
  public displayColumns1: string[];
  public displayColumns2: string[];
  public displayColumns3: string[];
  public eventLogs: any[];
  public group1: any;
  public group2: any;
  public group3: any;
  public isLoading: boolean;
  public showBasicInfo: boolean;

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private commonService: CommonService,
              private eventLogsService: EventLogsService,
              private matDialog: MatDialog,
              private toastMessagesService: ToastMessagesService) {
    this.displayColumns1 = [
      'item_group1_description',
      'annual_prediction',
      'gift_ice_cream',
      'cash',
      'hasInvoice',
      'hasZds',
      'hasDiscount',
      'cash_gift_estimate',
      'discount_estimate',
      'discount_estimate_at_the_end',
      'total_benefits_estimate',
      'net_turnover',
      'cost'
    ];
    this.displayColumns2 = [
      'item_group2_description',
      'annual_prediction',
      'gift_ice_cream',
      'cash',
      'hasInvoice',
      'hasZds',
      'hasDiscount',
      'cash_gift_estimate',
      'discount_estimate',
      'discount_estimate_at_the_end',
      'total_benefits_estimate',
      'net_turnover',
      'cost'
    ];
    this.displayColumns3 = [
      'item_material_description',
      'annual_prediction',
      'gift_ice_cream',
      'cash',
      'hasInvoice',
      'hasZds',
      'hasDiscount',
      'cash_gift_estimate',
      'discount_estimate',
      'discount_estimate_at_the_end',
      'total_benefits_estimate',
      'net_turnover',
      'cost'
    ];
    this.isLoading = false;
    this.showBasicInfo = false;
  }

  public ngOnInit(): void {
    this.activatedRoute.params.subscribe(async (params) => {
      this.detailsId = +params.id;
      await this.initDetails();
      await this.initUser();
      await this.initBasicInfo();
      await this.initEvents();
    });
  }

  private async initEvents() {
    this.eventLogs = await this.eventLogsService.getAgreementEventLogs(this.detailsId);
    // this.eventLogs = await this.eventLogsService.getEventLogs('event_log/agreement', this.detailsId);
  }

  private async initDetails() {
    try {
      this.isLoading = true;
      this.details = await this.commonService.getList(`agreement/${this.detailsId}`);
      this.group1 = this.details.details.filter(detail => detail.group_assign === 1);
      for (const item of this.group1) {
        item.hasInvoice = item.on_invoice.length > 0;
        item.hasZds = item.zds3.length > 0;
        item.hasDiscount = item.discount_at_the_end.length > 0;
      }

      const indexGroup1 = this.group1.findIndex(record => record.is_total);
      this.group1[indexGroup1].item_group1_description = 'ΣΥΝΟΛΑ ΑΝΑ ΟΜΑΔΑ ΕΙΔΩΝ 1 ΧΩΡΙΣ ΦΠΑ';
      if (indexGroup1 !== -1) {
        this.group1.push(this.group1.splice(indexGroup1, 1)[0]);
      }


      this.group2 = this.details.details.filter(detail => detail.group_assign === 2);
      for (const item of this.group2) {
        item.hasInvoice = item.on_invoice.length > 0;
        item.hasZds = item.zds3.length > 0;
        item.hasDiscount = item.discount_at_the_end.length > 0;
      }

      const indexGroup2 = this.group2.findIndex(record => record.is_total);
      this.group2[indexGroup2].item_group2_description = 'ΣΥΝΟΛΑ ΑΝΑ ΟΜΑΔΑ ΕΙΔΩΝ 2 ΧΩΡΙΣ ΦΠΑ';
      if (indexGroup2 !== -1) {
        this.group2.push(this.group2.splice(indexGroup1, 1)[0]);
      }

      this.group3 = this.details.details.filter(detail => detail.group_assign === 3);
      for (const item of this.group3) {
        item.hasInvoice = item.on_invoice.length > 0;
        item.hasZds = item.zds3.length > 0;
        item.hasDiscount = item.discount_at_the_end.length > 0;
      }

      const indexGroup3 = this.group3.findIndex(record => record.is_total);
      this.group3[indexGroup3].item_material_description = 'ΣΥΝΟΛΑ ΑΝΑ ΚΩΔΙΚΟ ΕΙΔΟΥΣ ΧΩΡΙΣ ΦΠΑ';
      if (indexGroup2 !== -1) {
        this.group3.push(this.group3.splice(indexGroup1, 1)[0]);
      }

    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isLoading = false;
    }
  }

  private async initBasicInfo() {
    this.basicDetailsConfig = {
      subtitle: [],
      title: 'Λεπτομέρειες συμφωνίας'
    };
    await this.initializeActions();
  }

  private async initializeActions() {
    const toolTip = 'Η συμφωνία είναι ήδη ακυρωμένη';
    const actions = [];

    const action1 = {
      function: () => {
        this.deleteAction();
      },
      showAction: this.details.status_id !== 9,
      title: 'Ακύρωση συμφωνίας',
      icon: 'delete',
      color: '#013e81',
      tooltip: toolTip
    };

    const action2 = {
      function: () => {
        this.downloadPDF();
      },
      showAction: true,
      title: 'Λήψη PDF',
      icon: 'picture_as_pdf',
      color: '#013e81',
    };

    actions.push(action1);
    actions.push(action2);

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = await this.commonService.showActions(this.user);
    } else {
      this.basicDetailsConfig.showActions = false;
    }
    this.showBasicInfo = true;
  }

  private async initUser() {
    this.user = await this.authService.getUser();
    await this.initBasicInfo();
  }

  private deleteAction() {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Ακύρωση Συμφωνίας',
        message: 'Είστε σίγουροι ότι θέλετε να ακυρώσετε την συμφωνία?'
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.commonService.updateObject(`agreement/cancel/${this.detailsId}`, {});
          this.toastMessagesService.toastMessages(`Η συμφωνία ακυρώθηκε με επιτυχία`);
          location.reload();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  async downloadPDF() {
    try {
      await this.commonService.getPDF(`agreement/PDF/${this.detailsId}`, `Συμφωνία ${this.details.sale_point.customer_name} - ${this.details.year}`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  showInfo(detail: any, object: string, title: string) {
    this.matDialog.open(MiniTableAgreementInfoComponent, {
      width: '400px',
      height: '300px',
      data: {
        title,
        data: detail[object]
      }
    });
  }

  // todo: proper user management to see logs
  public showEventLogs(): boolean {
    return true;
  }
}
